import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {  DateRange, Bookmarks, ExitToApp, CalendarToday, Settings  } from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";


import LogoutPage from "views/UserProfile/LogoutPage.js";
import { Assignment, Commute } from "@material-ui/icons/";
import BudgetDashboard from "../views/Budget/BudgetDashboard";
import BudgetRoundList from "../views/Budget/BudgetRoundList";
import BudgetTimelinePlanner from "../views/Budget/BudgetTimelinePlanner";
import BudgetForm from "../views/Budget/BudgetForm";

import BudgetCategorySettings from "../views/Budget/BudgetCategorySettings";

//import Goto from "views/Consent/Goto";

let ps;

const categoryRoutes = [
    { name: "หมวดงบลงทุน", path: "/settings/capital", kind: "capital" },
    { name: "หมวดงบดำเนินงาน", path: "/settings/operating", kind: "operating" },
    { name: "หมวดย่อยงบดำเนินงาน", path: "/settings/subcategory", kind: "subcategory" }
].map(route => ({ ...route, layout: "/budget", icon: Bookmarks,
    component: () => <BudgetCategorySettings key={route.kind} kind={route.kind} /> }));

const routes = [
    {
      name: "Dashboard คำของบประมาณ",
      icon: Bookmarks,
      component: BudgetDashboard,
      layout: "/budget",
      path: "/index",
    },
    {
      name: "บริหารจัดการรอบการขอ",
      icon: Bookmarks,
      component: BudgetRoundList,
      layout: "/budget",
      path: "/round",
    },
    {
      name: "Timeline Planner",
      icon: Bookmarks,
      component: BudgetTimelinePlanner,
      layout: "/budget",
      path: "/timeline",
    },
    { name: "ตั้งค่า", icon: Settings, layout: "/budget", path: "/settings", collapse: true,
      state: "budgetSettings", views: categoryRoutes },
];

const switchRoutes = (
    <Switch>

    {routes.flatMap(route => route.views || [route]).map((prop, key) => {
     
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      
      return null;
    })}

        {/*<Route path="/vehicle/id/:VBID" component={Goto} />*/}
        {/*<<Route path="/consent/sign" component={ESignInstance} />*/}
        <Route path="/budget/request/form" component={BudgetForm} />
        <Redirect from="/budget" to="/budget/index" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Vehicle({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"ระบบงบประมาณ"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes.flatMap(route => route.views || [route])}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
